import { render, staticRenderFns } from "./logoffBox.vue?vue&type=template&id=4c986cd4&scoped=true&"
import script from "./logoffBox.vue?vue&type=script&lang=js&"
export * from "./logoffBox.vue?vue&type=script&lang=js&"
import style0 from "./logoffBox.vue?vue&type=style&index=0&id=4c986cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c986cd4",
  null
  
)

export default component.exports